import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentSvgrepoCom = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "24px",
	height: "32px",
	viewBox: "0 0 24 32",
	enableBackground: "new 0 0 24 32",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#1991ac",
			d: "M1.5,32h21c0.827,0,1.5-0.673,1.5-1.5v-21c0-0.017-0.008-0.031-0.009-0.047 c-0.002-0.023-0.008-0.043-0.013-0.065c-0.017-0.071-0.046-0.135-0.09-0.191c-0.007-0.009-0.006-0.02-0.013-0.029l-8-9 c-0.003-0.003-0.007-0.003-0.01-0.006c-0.06-0.064-0.136-0.108-0.223-0.134c-0.019-0.006-0.036-0.008-0.056-0.011 C15.557,0.012,15.53,0,15.5,0h-14C0.673,0,0,0.673,0,1.5v29C0,31.327,0.673,32,1.5,32z M16,1.815L22.387,9H16.5 C16.28,9,16,8.58,16,8.25V1.815z M1,1.5C1,1.224,1.225,1,1.5,1H15v7.25C15,9.059,15.655,10,16.5,10H23v20.5 c0,0.276-0.225,0.5-0.5,0.5h-21C1.22,31,1,30.78,1,30.5V1.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1991ac",
			d: "M5.5,14h13c0.276,0,0.5-0.224,0.5-0.5S18.776,13,18.5,13h-13C5.224,13,5,13.224,5,13.5S5.224,14,5.5,14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1991ac",
			d: "M5.5,18h13c0.276,0,0.5-0.224,0.5-0.5S18.776,17,18.5,17h-13C5.224,17,5,17.224,5,17.5S5.224,18,5.5,18z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1991ac",
			d: "M5.5,10h6c0.276,0,0.5-0.224,0.5-0.5S11.776,9,11.5,9h-6C5.224,9,5,9.224,5,9.5S5.224,10,5.5,10z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1991ac",
			d: "M5.5,22h13c0.276,0,0.5-0.224,0.5-0.5S18.776,21,18.5,21h-13C5.224,21,5,21.224,5,21.5S5.224,22,5.5,22z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1991ac",
			d: "M5.5,26h13c0.276,0,0.5-0.224,0.5-0.5S18.776,25,18.5,25h-13C5.224,25,5,25.224,5,25.5S5.224,26,5.5,26z"
		})
	] })
});
export default SvgDocumentSvgrepoCom;
